module.exports = __webpack_public_path__ + "static/ux_pack-1308b4d81e578a93c671f82aea50ca83.png";